import React from "react";
import "./index.scss";

interface GiftItemProps {
  title: string;
  subtitle?: string;
  imgUrl: string;
  alt: string;
  size: string;
  nested?: boolean;
}

const GiftItem: React.FC<GiftItemProps> = ({
  title,
  subtitle,
  imgUrl,
  alt,
  size,
  nested = false,
}) => {
  return (
    <div className="gift-item-component">
      <div className="gift-item__title">{title}</div>
      {subtitle && <div className="gift-item__title">{subtitle}</div>}
      {nested ? (
        <div className="nested-img">
          <img src={imgUrl} alt={alt} style={{ width: size }} loading="lazy" decoding="async" />
        </div>
      ) : (
        <img src={imgUrl} alt={alt} style={{ width: size }} loading="lazy" decoding="async" />
      )}
    </div>
  );
};

export default GiftItem;
